<template>
    <IntegrationsTabs tab-key="available">
        <div
            class="flex w-full flex-wrap gap-x-4 gap-y-8 py-10 md:grid md:grid-cols-2 lg:grid-cols-3"
        >
            <SlackIntegrationBox
                @openNew="slackIntegrationModalOpened = true"
            />

            <TeamsIntegrationBox
                @openNew="teamsIntegrationModalOpened = true"
            />
        </div>
    </IntegrationsTabs>
</template>

<script lang="ts" setup>
import useIntegrations from "../composables/useIntegrations";

const { teamsIntegrationModalOpened, slackIntegrationModalOpened } =
    useIntegrations();
</script>
